// src/pages/Register.jsx

import Hero from "../component/header";
import Footer from "../component/Footer";
import Register from "../component/Register";

const Home = () => {
  return (
    <div className="App">
      <Hero isBlack={true} />

      <div className="py-[100px]">
        <Register />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
